import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-step-company-contact-mautic',
  templateUrl: './step-company-contact-mautic.component.html',
  styleUrls: ['./step-company-contact-mautic.component.scss']
})
export class StepCompanyContactMauticComponent implements OnInit {

  formData: any = {};
  @ViewChild('form1', { static: false }) form: ElementRef<any>;

  constructor(
    router: ActivatedRoute,
    @Inject('FORM_API_URL') public formApiUrl: string
  ) {

      router.queryParams.subscribe(
        query => {
            
            this.formData = query;
            setTimeout(() => this.form.nativeElement.submit(), 500);
            
        }
      )

  }

  ngOnInit(): void {
  }

}
